<script>
import BaseVolanInputValidate from './BaseVolanInputValidate';
import InputNumber from 'primevue/inputnumber';
/**
 * Componente para input de texto, numérico ou outro input quelquer
 *
 * Substitui o componente VTextField
 *
 * [Wraper para inputnumber](https://primevue.org/inputnumber)
 * @displayName VolanNumber (VTextField)
 *
 * Bugs conhecidos
 * Ao utiliza suffix, a primevue/inputnumber se comporta de maneira erratica, duplicando números e gerando problemas com
 * o cursor
 */
export default {
  name: 'VolanInput',
  components: {InputNumber},
  extends: BaseVolanInputValidate,
  inheritAttrs: false,
  props: {
    locale: {
      type: String,
      default: 'pt-BR'
    },
    isProportion: {
      type: Boolean
    },
    minFractionDigits: {
      type: Number,
      default: 3
    },
    maxFractionDigits: {
      type: Number,
      default: 10
    }
  },
  computed: {
    listenerComputed() {
      const listeners = {...this.$listeners};
      delete listeners.input;
      return listeners;
    }
  },
};
</script>

<template>
  <div class="field volanTextContainer mt-2 mb-2 pt-1">
    <label class="block"
           :for="computedId"
    >{{ computedLabel }}</label>
    <InputNumber v-if="isProportion"
                 :id="computedId"
                 v-bind="$attrs"
                 :value="parseFloat(value)*100"
                 :class="{'p-invalid': isValid===false}"
                 :disabled="isDisabled"
                 inputmode="numeric"
                 :readonly="isReadonly"
                 :locale="locale"
                 :minFractionDigits="minFractionDigits"
                 :maxFractionDigits="maxFractionDigits"
                 v-on="listenerComputed"
                 @input="$emit('input', $event/100)"
                 @focus="onInputFocus"
                 @blur="onInputBlur"
    />
    <InputNumber v-else
                 :id="computedId"
                 v-bind="$attrs"
                 :value="value"
                 :class="{'p-invalid': isValid===false}"
                 :disabled="isDisabled"
                 inputmode="numeric"
                 :readonly="isReadonly"
                 :locale="locale"
                 :minFractionDigits="minFractionDigits"
                 :maxFractionDigits="maxFractionDigits"
                 v-on="$listeners"
                 @focus="onInputFocus"
                 @blur="onInputBlur"
    />
    <small v-for="(message, index) of internalErrorMessages"
           :key="index"
           class="p-error block"
    >{{ message }}</small>
    <small v-if="!internalErrorMessages.length"
           class="block"
    >{{ hintComputed }}</small>
  </div>
</template>

<style lang="scss">
.volanTextContainer {
  small {
    min-height: 1.5em;
  }
}
</style>
